/* A group is only a wrapper: its rows lay out as direct rows of the menu */
.group {
  display: contents;
}

/* A plugin component can render nothing: a group with no row is hidden, and its divider with it */
.group:not(:has([role^='menuitem'])) {
  display: none;
}

/* A divider shows only below a visible group: never as the first thing in the menu */
.group:not(.group:has([role^='menuitem']) ~ .group) > .separator {
  display: none;
}
